import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'geojsonBounds',
    standalone: false,
})
export class GeojsonBoundsPipe implements PipeTransform {
    /**
     * Calculates the bounding box of a GeoJSON polygon (outer ring only)
     * @param geojson The GeoJSON object with type 'Polygon' and coordinates
     * @returns Bounds of the polygon, or null when the geometry is not a polygon
     */
    transform(geojson: any): google.maps.LatLngBounds | null {
        if (!geojson || geojson.type !== 'Polygon' || !geojson.coordinates?.[0]?.length) {
            return null;
        }

        // GeoJSON coordinates are [lng, lat]
        const bounds = new google.maps.LatLngBounds();
        geojson.coordinates[0].forEach(([lng, lat]: number[]) => bounds.extend({ lat, lng }));
        return bounds;
    }
}
